import { faCopy, faUser } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { RankmiTable } from '@rankmi/rankmi-table'
import { Button, Divider, Input } from 'antd'
import { useTranslation } from 'react-i18next'
import { Modal } from 'components/reusables/modal'
import { ModalButtons } from 'components/reusables/modalButtons'
import { SuccessToast } from 'components/ui/toast/toastsTemplates'

import { IPanelist } from 'interfaces/webinars'
import { useIsMobile } from 'hooks/useIsMobile'
import {
  PanelistName,
  PanelistEmail,
  JoinURL,
  CopyButton,
  RankmiTableWrapper,
  PanelistResponsiveTitle,
} from '../styled'
import { PanelistRow } from './mobile/PanelistRow'

interface IModalPanelist {
  show: boolean
  close: () => void
  panelList: IPanelist[]
}

export const ModalPanelist = ({ panelList, show, close }: IModalPanelist) => {
  const { t } = useTranslation()
  const prefix = 'webinars'
  const isMobile = useIsMobile()

  const columsModal = [
    {
      title: `${t(`${prefix}.modal.table.panelistName`)}`,
      width: 175,
      render: (data: IPanelist) => (
        <div>
          <PanelistName>{data.name}</PanelistName>
          <PanelistEmail>{data.email}</PanelistEmail>
        </div>
      ),
    },
    {
      title: `${t(`${prefix}.modal.table.urlAccess`)}`,
      dataIndex: 'joinUrl',
      key: 'joinUrl',
      width: 300,
      render: (joinUrl: string) => (
        <JoinURL>
          <Input placeholder={joinUrl} value={joinUrl} />
        </JoinURL>
      ),
    },
    {
      width: 10,
      hideable: false,
      align: 'center',
      fixed: 'right',
      render: (data: IPanelist) => (
        <CopyButton>
          <Button type="link" onClick={() => copyText(data.joinUrl)}>
            <FontAwesomeIcon style={{ paddingRight: '8px' }} icon={faCopy} />
            {t(`${prefix}.modal.table.btnCopyUrl`)}
          </Button>
        </CopyButton>
      ),
    },
  ]

  const showToast = () => {
    SuccessToast(t(`${prefix}.modal.alertCopy`))
  }

  const locale = {
    header: {
      rowsCount: t(`${prefix}.modal.table.rowsCount`),
      rowsCount_plural: t(`${prefix}.modal.table.rowsCountPlural`),
    },
  }

  const copyText = async (url: string) => {
    try {
      await navigator.clipboard.writeText(url)
      showToast()
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <Modal
        isOpen={show}
        title={t(`${prefix}.modal.title`)}
        maxwidth={800}
        maxheight={400}
        actions={
          <ModalButtons
            secondaryText={t(`${prefix}.modal.btnClose`)}
            secondaryAction={() => close()}
          />
        }
        close={() => close()}
      >
        <>
          {t(`${prefix}.modal.description`)}
          {!isMobile ? (
            <RankmiTableWrapper>
              <RankmiTable
                columnHeaders={columsModal}
                data={panelList}
                responsive
                countIcon={faUser}
                total={panelList.length}
                locale={locale}
              />
            </RankmiTableWrapper>
          ) : (
            <>
              <PanelistResponsiveTitle>
                <span>{t(`${prefix}.modal.modalPanelistResponsiveTitle`)}</span>
                <Divider className="divider" />
              </PanelistResponsiveTitle>
              {panelList.map((panelist) => (
                <PanelistRow key={panelist.email} panelist={panelist} />
              ))}
            </>
          )}
        </>
      </Modal>
    </>
  )
}
